__turbopack_context__.v({
  "alignedImage": "QUcewW_alignedImage",
  "downloadIcon": "QUcewW_downloadIcon",
  "fileDownload": "QUcewW_fileDownload",
  "fullWidthImage": "QUcewW_fullWidthImage",
  "inlineWithText": "QUcewW_inlineWithText",
  "leftAlignedImage": "QUcewW_leftAlignedImage",
  "richText": "QUcewW_richText",
  "rightAlignedImage": "QUcewW_rightAlignedImage",
  "yt": "QUcewW_yt",
});
